import { render, staticRenderFns } from "./FinalReceipt.vue?vue&type=template&id=7048c10a&scoped=true&"
import script from "./FinalReceipt.vue?vue&type=script&lang=js&"
export * from "./FinalReceipt.vue?vue&type=script&lang=js&"
import style0 from "./FinalReceipt.vue?vue&type=style&index=0&id=7048c10a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7048c10a",
  null
  
)

export default component.exports